import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FcpDateInputComponent } from './fcp-date-input.component';
import { FcpInputModule } from '../fcp-input';

const components = [FcpDateInputComponent];
@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, FcpInputModule],
    declarations: components,
    exports: components
})
export class FcpDateInputModule {}
